import React from 'react';

import './single-column.css';

export default ({ children }) => <div className="layout__single-column">
  {children}
</div>;
